var OplevMere = OplevMere || {};

OplevMere.newsFeed = OplevMere.newsFeed || function () {

    this.init = function() {
        $.ajax( {
            url: "http://rss2json.com/api.json?rss_url=http://fetchrss.com/rss/578f26f38a93f8b90f7b23c660127667319.xml",
            dataType: "jsonp" 
        })
        .done(function(data) {
            showFeed(data);
        })
        .fail(function(data) {
            showFeed(data);
        });
        
	};

	this.showFeed = function(data){

	    var newsFeedList = document.getElementById('js-news-feed-list');

	    if ($('#js-news-feed-list').length) {
            if(data.status == 'ok'){
                var monthNames = [
                "Januar", "Februar", "Marts",
                "April", "Maj", "Juni", "Juli",
                "August", "September", "Oktober", 
                "November", "December"
                ];

                var output = '';

                for(var i=0;i<3;++i){

                    var link = data.items[i].link; 
                    var title = data.items[i].title;
                    var dateString = data.items[i].pubDate;
                    var dateArr = dateString.split(' ')[0].split('-');
                    var formatedMonth = dateArr[1] > 0 ? dateArr[1] - 1 : dateArr[1];
                    var date = new Date(dateArr[0],formatedMonth,dateArr[2]);
                    var text = data.items[i].description;

                    text = text.replace('<br><br>', '');
                    text = $.parseHTML(text)[0].data;

                    var day = date.getDate();
                    var monthIndex = date.getMonth();
                    var year = date.getFullYear();

                    output += '<li class="news-feed-item"><a class="news-feed-item__link" href="' +
                    link + '" ><svg class="icon news-feed-item__logo"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#logo_mark"></use></svg><p class="news-feed-item__title">' +
                    title + '</p><span class="news-feed-item__date">' + day + '. ' + monthNames[monthIndex] + ' ' + year +'</span><p class="news-feed-item__text">' + text +'</p></a></div>';
                }

                newsFeedList.innerHTML = output;
            }

            else{
                output += '<p>Der er desværre ingen nyheder fra Frilufstrådet.dk</p>'
                newsFeedList.innerHTML = output;
            }
        };

        

	};

    return {
		init : init,
        showFeed : showFeed
	};

}();